<div class="flex flex-col gap-2 text-sm">
  <label *ngIf="label" for="{{ id }}">{{ label }}</label>

  @if (inputType == 'numeric') {
    <p-inputNumber
      [(ngModel)]="value"
      [mode]="mode"
      [currency]="currency"
      [minFractionDigits]="2"
      [maxFractionDigits]="5"
      class="{{ helperText && colorClass[color] }} {{
        !dense ? 'py-4' : 'py-2'
      }} rounded-lg text-textPrimary"
      [ngClass]="helperText ? 'error' : ''"
      (ngModelChange)="onChange($event)"
    >
    </p-inputNumber>
  } @else if (inputType == 'phone') {
    <p-inputMask
      [id]="id"
      [mask]="mask"
      type="tel"
      [autocomplete]="autocomplete"
      [unmask]="true"
      [(ngModel)]="value"
      [placeholder]="placeholder"
      [autoClear]="false"
      (ngModelChange)="onPhoneChange($event)"
      (onBlur)="onPhoneBlur($event)"
      class="{{ (helperText || phoneIncompleteError) && colorClass[color] }} rounded-lg text-textPrimary"
      [ngClass]="helperText || phoneIncompleteError ? 'error' : ''"
    />
  } @else if (inputType == 'inputIcon') {
    <span class="p-input-icon-left">
      <i class="pi pi-user"></i>
      <input
        [formControl]="control"
        [autocomplete]="autocomplete"
        type="{{ type }}"
        pInputText
        id="{{ id }}"
        [placeholder]="placeholder"
        class="w-full {{ helperText && colorClass[color] }} {{
          !dense ? 'py-4' : 'py-2'
        }} rounded-lg text-textPrimary"
        [ngClass]="helperText ? 'error' : ''"
        (onChange)="onChange($event)"
        (blur)="onBlur($event)"
      />
    </span>
  } @else if (inputType == 'inputPassword') {
    <span class="p-input-icon-left">
      <i class="pi pi-lock z-10"></i>
      <p-password
        [formControl]="control"
        [autocomplete]="autocomplete"
        [feedback]="false"
        [toggleMask]="true"
        id="{{ id }}"
        [placeholder]="placeholder"
        styleClass="w-full"
        inputStyleClass="w-full {{ helperText && 'border-[#ff0000]' }} {{
          !dense ? 'py-4' : 'py-2'
        }} rounded-lg text-textPrimary"
        [ngClass]="helperText ? 'error' : ''"
        (onChange)="onChange($event)"
        (blur)="onBlur($event)"
      ></p-password>
    </span>
  } @else {
    <input
      *ngIf="control; else templateDriven"
      [formControl]="control"
      [autocomplete]="autocomplete"
      type="{{ type }}"
      pInputText
      id="{{ id }}"
      [placeholder]="placeholder"
      class="{{ helperText && colorClass[color] }} {{
        !dense ? 'py-4' : 'py-2'
      }} rounded-lg text-textPrimary"
      [ngClass]="helperText ? 'error' : ''"
      (onChange)="onChange($event)"
      (blur)="onBlur($event)"
    />
    <ng-template #templateDriven>
      <input
        type="{{ type }}"
        pInputText
        id="{{ id }}"
        [(ngModel)]="value"
        name="{{ name }}"
        [autocomplete]="autocomplete"
        [disabled]="disabled"
        [placeholder]="placeholder"
        class="{{ helperText && colorClass[color] }} {{
          !dense ? 'py-4' : 'py-2'
        }} rounded-lg text-textPrimary"
        [ngClass]="helperText ? 'error' : ''"
        required="{{ required }}"
        (ngModelChange)="onChange($event)"
        (blur)="onBlur($event)"
      />
    </ng-template>
  }

  <small *ngIf="helperText || phoneIncompleteError" class="text-[#ff0000]">{{
    helperText || phoneIncompleteError
  }}</small>
</div>
<!-- <input
    pInputText
    [(ngModel)]="selectedItem"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [type]="type"
    class="w-full"
    /> -->
